module.exports = __webpack_public_path__ + "static/media/stillCocktail.98821397.png";